import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";

import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import Validation from "../../../common/FormValidation";
import { CancelButton, SaveButton } from "../../../common/Button";

import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";

library.add(fas);

const AddOffCanvance = (props) => {
  const [selectedNumber, setSelectedNumber] = useState(1);
  const { postData, data } = useContext(Context);
  const [imagePreview, setImagePreview] = useState(null);
  const [errors, setErrors] = useState();
  const [formData, setFormData] = useState({
    name: "",
    image: null,
  });
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const handleChange = (e) => {
    if (e.target.type === "file") {
      const selectedImage = e.target.files[0];

      // Check if a file is selected
      if (selectedImage) {
        // Generate image preview
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreview(reader.result);
        };
        reader.readAsDataURL(selectedImage);

        // Update formData with the selected image
        setFormData({ ...formData, image: selectedImage });
      } else {
        // User canceled image selection, clear the image preview and formData
        setImagePreview(null);
        setFormData({ ...formData, image: null });
      }
    } else {
      // Handle text input
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      try {
        const formDataToSend = new FormData();
        formDataToSend.append("name", formData.name);
        formDataToSend.append("image", formData.image);
        formDataToSend.append("number", selectedNumber);

        // Check if data is defined
        if (data) {
          // Check if there's existing data with the same number
          const existingDataIndex = data.find(
            (item) => item.number === selectedNumber
          );

          if (existingDataIndex !== -1) {
            // Replace the old data with the new one
            data[existingDataIndex] = {
              name: formData.name,
              image: formData.image,
              number: selectedNumber,
            };
          } else {
            // Add new data if no existing data with the same number
            data.push({
              name: formData.name,
              image: formData.image,
              number: selectedNumber,
            });
          }
        }

        const response = await postData("/masters/solution", formDataToSend);
        if (response.success) {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        } else {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        }
        await setErrors();
      } catch (error) {
        console.log(error);
      }
    }
  };

  const validateForm = () => {
    let errors = {};
    const regexAlfaNumric = /^[A-Za-z0-9]+(\s[A-Za-z0-9]+)*$/;
    const regexAlfa = /^[A-Za-z]+(\s[A-Za-z]+)*$/;

    if (!formData.name) {
      errors.name = "Title is required";
    }

    if (!formData.image) {
      errors.image = "Image is required";
    }
    return errors;
  };
  const errorStyle = {
    color: "red",
    marginLeft: "5px",
    // fontSize: "11px",
  };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton />
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>Add Solution</Card.Title>
              <hr />
              <Container>
                <Row>
                  {/* Right side - Form */}
                  <Col md={12}>
                    <Container>
                      <Row className="">
                        <Col xxl={12} xl={12} md={10}>
                          <Form
                            onSubmit={handleSubmit}
                            role="form"
                            className=".ourclientclass"
                            encType="multipart/form-data"
                          >
                            <Row>
                              <Col md={4}>
                                <Form.Label column sm={3}>
                                  Number
                                </Form.Label>
                                <Form.Control
                                  as="select"
                                  name="number"
                                  value={selectedNumber}
                                  onChange={(e) =>
                                    setSelectedNumber(parseInt(e.target.value))
                                  }
                                >
                                  {[1, 2, 3, 4, 5].map((num) => (
                                    <option key={num} value={num}>
                                      {num}
                                    </option>
                                  ))}
                                </Form.Control>
                              </Col>
                              <Col md={6}>
                                <Form.Label column sm={3}>
                                  Name
                                </Form.Label>
                                <Col sm={6}>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder="Name"
                                        id="inputEmail3"
                                        className="input-mandatory"
                                      />
                                    </InputGroup>
                                    {errors?.name && (
                                      <span style={errorStyle}>
                                        {errors?.name}
                                      </span>
                                    )}
                                  </Form.Group>
                                </Col>
                              </Col>
                              <Col md={6}>
                                <Form.Label column sm={3}>
                                  Image
                                </Form.Label>
                                <Col sm={6}>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="file"
                                        name="image"
                                        onChange={handleChange}
                                        accept="image/*"
                                      />
                                    </InputGroup>
                                    {errors?.image && (
                                      <span style={errorStyle}>
                                        {errors?.image}
                                      </span>
                                    )}
                                  </Form.Group>
                                </Col>

                                {/* Left side - Image Preview */}
                                <Col md={6}>
                                  <Row>
                                    <Col md={12}>
                                      {imagePreview ? (
                                        <img
                                          src={imagePreview}
                                          alt="Image Preview"
                                          className="table-image"
                                          style={{
                                            height: "100px",
                                            width: "100px",
                                            marginLeft: "150px",
                                            margin: "2px",
                                          }}
                                        />
                                      ) : (
                                        <p style={{ marginLeft: "100px" }}>
                                          No image selected
                                        </p>
                                      )}
                                    </Col>
                                  </Row>
                                </Col>
                              </Col>
                            </Row>
                            <Row className="mt-5 pb-3">
                              <div className="d-flex justify-content-center">
                                <Link>
                                  <CancelButton
                                    name={"cancel"}
                                    handleClose={props.handleClose}
                                  />
                                </Link>
                                <SaveButton
                                  name={"save"}
                                  handleSubmit={handleSubmit}
                                />
                              </div>
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
